"use client";

import { ChickyLogo } from "@/components/fullscreen/ChickyLogo";
import { BRAND_ASSETS } from "@/lib/brand-assets";
import { isSchoolPath } from "@/lib/school-routes";
import Image from "next/image";
import { usePathname } from "next/navigation";

interface BrandLockupProps {
  surface: "light" | "dark";
  className?: string;
  priority?: boolean;
  alt?: string;
}

export function BrandLockup({
  surface,
  className,
  priority = false,
  alt = "ChickyTutor",
}: BrandLockupProps) {
  const school = isSchoolPath(usePathname());
  if (school) {
    return (
      <ChickyLogo
        subscribed={false}
        variant={surface === "dark" ? "liceo" : "default"}
        src="/ui/liceoculturalbritanicologo.png"
        alt="Liceo Cultural Británico"
        className={className}
      />
    );
  }
  return (
    <Image
      src={BRAND_ASSETS.lockup[surface]}
      alt={alt}
      width={1080}
      height={300}
      className={className}
      priority={priority}
    />
  );
}
